var _path, _path2, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckboxCircleCompleted(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9974 9.99945C19.9974 15.2448 15.7453 19.497 10.4999 19.497C5.25462 19.497 1.00244 15.2448 1.00244 9.99945C1.00244 4.75413 5.25462 0.501953 10.4999 0.501953C15.7453 0.501953 19.9974 4.75413 19.9974 9.99945Z",
    fill: "white",
    stroke: "#293990"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4999 19.4408C15.7147 19.4408 19.942 15.2134 19.942 9.99872C19.942 4.784 15.7147 0.556641 10.4999 0.556641C5.28523 0.556641 1.05786 4.784 1.05786 9.99872C1.05786 15.2134 5.28523 19.4408 10.4999 19.4408Z",
    fill: "white",
    stroke: "#293990"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.4999,
    cy: 10.0004,
    r: 6.9457,
    fill: "#293990"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxCircleCompleted);
export default __webpack_public_path__ + "static/media/checkbox-circle-completed.f8487c26df60f0a96ba6a780cebc5fa3.svg";
export { ForwardRef as ReactComponent };